import PersistAffordabilityButton from './PersistAffordabilityButton'
import PersistAffordabiltyButtonContainer from './PersistAffordabilityButtonContainer'

export default PersistAffordabiltyButtonContainer(PersistAffordabilityButton)
